import { module as BaseModule } from "modujs"
import { gsap } from "gsap"
import { Observer } from "gsap/Observer"

gsap.registerPlugin(Observer)

export default class extends BaseModule {
  init() {
    this.medias = this.el.querySelectorAll("[data-displacement]")

    if (window.innerWidth < 768) {
      this.float()
    } else {
      this.observer()
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth < 768) {
        this.killObserver()
        this.float()
      } else {
        this.killFloatAnimation()
        this.observer()
      }
    })
  }

  float() {
    this.floatAnimations = []

    this.medias.forEach((media, i) => {
      const direction = i % 2 === 0 ? -1 : 1
      const delay = 0.1 * i
      const amplitude = 15

      const animX = gsap.to(media, {
        x: direction * amplitude,
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: delay,
      })

      const animY = gsap.to(media, {
        y: direction * amplitude,
        duration: 4,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: delay + 0.5,
      })

      this.floatAnimations.push(animX, animY)
    })
  }

  killFloatAnimation() {
    if (this.floatAnimations) {
      this.floatAnimations.forEach((anim) => anim.kill())
      this.floatAnimations = null

      this.medias.forEach((media) => {
        gsap.set(media, { x: 0, y: 0 })
      })
    }
  }

  observer() {
    this.pointerObserver = Observer.create({
      target: window,
      type: "pointer",
      onMove: ({ x, y }) => {
        if (window.innerWidth < 768) return

        const normalizedX = +(
          gsap.utils.normalize(0, window.innerWidth, x) - 0.5
        ).toFixed(4)
        const normalizedY = +(
          gsap.utils.normalize(0, window.innerHeight, y) - 0.5
        ).toFixed(4)

        this.medias.forEach((media, i) => {
          gsap.to(media, {
            x: normalizedX * 60 * (i % 2 === 0 ? -1 : 1),
            y: normalizedY * 60 * (i % 2 === 0 ? -1 : 1),
            duration: 1,
            delay: 0.1 * i,
          })
        })
      },
    })
  }

  killObserver() {
    if (this.pointerObserver) {
      this.pointerObserver.kill()
      this.pointerObserver = null

      this.medias.forEach((media) => {
        gsap.set(media, { x: 0, y: 0 })
      })
    }
  }
}
